<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex xs12 sm6 v-for="item in items" :key="item.id">
                <v-layout mt-1>
                    <v-card dark hover class="card blue-grey darken-3">
                        <v-card-title class="font-weight-bold font-italic light-blue--text text--lighten-4">{{ item.item }}</v-card-title>
                    </v-card>
                    <v-btn icon @click="remove(item.id)">
                    <v-icon color="red lighten-2" x-large>remove_circle_outline</v-icon>
                    </v-btn>
                </v-layout>        
            </v-flex>
            <v-flex xs12>
                <popupitems :liste=idListe @projectAdded="snackbar = true" @add="refresh" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Popupitems from '@/components/Popupitems'

export default {
    data() {
        return {
            idListe: this.$route.params.id,
            items: [],
            rang: 0,
            snackbar: false
        }
    },
    created() {
        this.rang = this.$store.state.listes.map(function(item) {
            return item.id
        }).indexOf(this.idListe);
        this.items = this.$store.state.listes[this.rang].items;
    },
    components: {
        Popupitems
    },
    methods: {
        remove(index) {
            const data = {
                index: index,
                idListe: this.idListe
            }
            this.$store.dispatch('supprItem', data);
        },
        refresh() {
            this.items = this.$store.state.listes[this.rang].items;
        }
    }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 10px;
    width: 80%;
  }
</style>
